import { useIntl } from 'react-intl';

import { Anchor } from '../../../../design-system/components/anchor/Anchor';
import { Typography } from '../../../../design-system/components/typography/Typography';
import { useUrlGenerator } from '../../../hooks/useUrlGenerator';

type Props = {
    typographyScale?: 'primary-xxs-regular' | 'primary-xs-regular';
    isShortMention?: boolean;
    obfuscateFooterNewsletterLinks?: boolean;
};

export function CguContentDescription({
    typographyScale = 'primary-xxs-regular',
    isShortMention = false,
    obfuscateFooterNewsletterLinks,
}: Props) {
    const { formatMessage } = useIntl();
    const { generatePath } = useUrlGenerator();

    return (
        <div>
            {!isShortMention ? (
                <>
                    <Typography scale={typographyScale} as="p">
                        {formatMessage({
                            id: 'global.component.cguMention.content.part1.label',
                        })}
                    </Typography>
                    <Typography scale={typographyScale} as="p">
                        {formatMessage(
                            {
                                id: 'global.component.cguMention.content.part2.label',
                            },
                            {
                                email: (
                                    <Anchor
                                        key="email"
                                        href="mailto:data-privacy@evaneos.com"
                                        target="_blank"
                                    >
                                        data-privacy@evaneos.com
                                    </Anchor>
                                ),
                            },
                        )}
                    </Typography>
                </>
            ) : null}
            <Typography scale={typographyScale} as="p">
                {formatMessage(
                    {
                        id: 'global.component.cguMention.content.part3.label',
                    },
                    {
                        link: (chunks) => (
                            <Anchor
                                key="link"
                                obfuscate={obfuscateFooterNewsletterLinks}
                                href={generatePath('confidentiality')}
                                target="_blank"
                            >
                                {chunks}
                            </Anchor>
                        ),
                    },
                )}
            </Typography>
        </div>
    );
}
